export default __webpack_public_path__ + "static/Card28-e39386f0d42a233170eda5aedcee585c.png";